module.exports = __webpack_public_path__ + "assets/6532c233af82a8bcb51b0a18459c7c7e.mp3";